<template>
  	<builder-row :removeable="removeable" :label="label" @remove="$emit('remove')">
		<div class="input-wrapper" v-if="!hideKey">
			<input type="text" class="parameterKey" max="200" :placeholder="placeholderKey" :value="parameterKey" @input="$emit('update:parameterKey', $event.target.value)" :readonly="keyReadOnly">
			<div class="text-xl font-bold">&equals;</div>
		</div>
		<input type="text" class="parameterValue" max="200" :placeholder="placeholderValue" :value="parameterValue" @input="$emit('update:parameterValue', $event.target.value)" :readonly="valueReadOnly">
  	</builder-row>
</template>

<script>
import BuilderRow from './BuilderRow.vue';
export default {
	components: { BuilderRow },
	props: {
		hideKey: Boolean,
		keyReadOnly: Boolean,
		label: String,
		parameterKey: String,
		parameterValue: String,
		placeholderKey: String,
		placeholderValue: String,
		removeable: Boolean,
		valueReadOnly: Boolean,
	},
	emits: ["update:parameterKey", "update:parameterValue", "remove"]
};
</script>